import { features } from "@/mocks/scandal";
import SectionHead from "./SectionHead";

export default function FeatureRead() {
  return (
    <section id="feature" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHead
          eyebrow="深扒长文 / LONG READ"
          title="本周深度深扒：把一个瓜拆完整"
          desc="话题墙上可能只是零散碎片，这里才是把每条料串成完整证据链的深扒长文。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {features.map((f, i) => (
            <article
              key={f.title}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-foreground-950/6 bg-background-50 transition-all hover:-translate-y-0.5 hover:border-foreground-950/20 sm:flex-row"
            >
              <div className={"relative overflow-hidden sm:w-2/5 " + (i % 2 === 1 ? "sm:order-2" : "")}>
                <img
                  src={f.img}
                  alt={f.title + " 深扒"}
                  title={f.title + " 深扒"}
                  className="h-44 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105 sm:h-full"
                />
                <span className="absolute left-3 top-3 rounded-md bg-foreground-950/85 px-2 py-1 font-label text-[11px] text-background-50">
                  {f.cat}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-primary-100 px-2.5 py-0.5 font-label text-[11px] text-primary-700">
                    {f.tag}
                  </span>
                  <span className="flex items-center gap-2 font-label text-[11px] text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line" />
                      {f.read}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-refresh-line" />
                      {f.date}
                    </span>
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                  {f.title}
                </h3>
                <p className="mt-2 line-clamp-3 text-[13px] leading-6 text-foreground-600">{f.summary}</p>
                <span className="mt-auto inline-flex items-center gap-1.5 pt-4 font-label text-xs font-medium text-foreground-700">
                  阅读全文深扒
                  <i className="ri-arrow-right-line text-xs transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}